import Link from 'next/link';
import { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import { Icon } from '../../components/ui/icon';
import { PrivacyAndLegal } from '../../types/contentstack';
import { classnames } from '../../utils/classnames';
import { mediaScreen } from '../../utils/mediaScreen';

export const LegalMobileMenu: FunctionComponent<{
  url: string;
  leftMenuItems: PrivacyAndLegal[];
}> = ({ url, leftMenuItems }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <MobileMenu>
      <MobileToggle onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <span>Legal</span>{' '}
        <Icon name={`arrow-${isMenuOpen ? 'up' : 'down'}`} color="white" />
      </MobileToggle>

      {isMenuOpen &&
        leftMenuItems?.map((item, index) => (
          <Link href={item.url as string} key={`left-menu-item-${index}`}>
            <span
              className={classnames({
                link: true,
                active: item.url === url,
              })}
            >
              {item.title}
            </span>
          </Link>
        ))}
    </MobileMenu>
  );
};

const MobileMenu = styled.div`
  display: none;

  ${mediaScreen('xs', 'sm')} {
    display: block;
  }

  .link {
    color: white;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 15px;
    display: block;

    &:hover {
      text-decoration: underline;
    }

    &.active {
      font-weight: bold;
      color: ${(props) => props.theme.colors.teal};
    }
  }
`;

const MobileToggle = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: 16px;
`;

export default LegalMobileMenu;
